export abstract class AbstractAppComponent {
  projectName: string;
}
